import { createSelector } from 'reselect';
import moment from 'moment';

import {
  EVENTS_REQUESTED,
  EVENTS_REQUESTED_ERROR,
  EVENTS_REQUESTED_SUCCESS,
  EVENTS_RESET,
} from '../actions/events';
import { getSearchTerm } from './search';

const initialState = {
  data: [],
  hasFailed: false,
  isRequesting: false,
  isSuccessful: false,
  hasMore: true,
};

const events = (state = initialState, action) => {
  switch (action.type) {
    case EVENTS_REQUESTED:
      return {
        ...state,
        hasFailed: false,
        isRequesting: true,
        isSuccessful: false,
      };
    case EVENTS_REQUESTED_SUCCESS:
      return {
        data: [...state.data, ...action.events],
        hasFailed: false,
        hasMore: true,
        isRequesting: false,
        isSuccessful: true,
      };
    case EVENTS_REQUESTED_ERROR:
      return {
        ...state,
        hasFailed: true,
        isRequesting: false,
        isSuccessful: false,
        hasMore: false,
      };
    case EVENTS_RESET:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
};

const getEvents = state => state.events.data;

function filterEventsBySearchTerm(events, searchTerm) {
  if (searchTerm === '') {
    return events;
  }

  return events.filter((event) => {
    return event.title.toLowerCase().includes(searchTerm.toLowerCase());
  });
}

const getEventsBySearchTermState = createSelector(
  [getEvents, getSearchTerm],
  (events, searchTerm) => filterEventsBySearchTerm(events, searchTerm),
);

// TODO: Must also sort by time within the dates
function buildEventsByDay(events) {
  return events.reduce((acc, event) => {
    const date = moment.unix(event.startDateTime).format('YYYY-MM-DD');
    const index = acc.findIndex(val => {
      return date === val.startDate;
    });

    if (index > -1) {
      acc[index].events.push(event);
    } else {
      acc.push({
        events: [].concat(event),
        startDate: date,
      });
    }
    return acc;
  }, []);
}

export const getEventsByDayState = createSelector(
  [getEventsBySearchTermState],
  (events) => buildEventsByDay(events),
);

export default events;



// WEBPACK FOOTER //
// ./src/redux/reducers/events.js